import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function loadPlayerScript() {
  const script = document.createElement('script') as HTMLScriptElement;

  script.type = 'text/javascript';
  script.src = '/assets/player-scripts/player.js';
  script.async = true;
  document.head.appendChild(script);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => loadPlayerScript())
  .catch(err => console.error(err));
